
import {  Prop, Vue, Component, Watch } from "vue-property-decorator";
import SystemViewTreeNode from '@/types/sv-data/system-view/SystemViewTreeNode';
import api from "@/services/api.service";
import { Getter } from 'vuex-class';
import { UserPermissions, FeaturesList } from '@/store/types';
import { get } from 'lodash';
import { SetupSummaryResponse, ServerOverview } from '@/types/sv-data/system-view/SetupSummary';
import { truncateString } from "@/filters";
import PingButton from "@/components/system-view/PingButton.vue";
import { CustomFieldValues, CustomFieldTableTypes } from '@/store/custom-fields/types';
import customFieldsApi from "@/services/api.customField.service";
import CustomDefinedFieldsDisplay from '../custom-fields/CustomDefinedFieldsDisplay.vue';

@Component({
	components: {
		PingButton,
		"custom-fields-display": CustomDefinedFieldsDisplay
	},
	filters: {
		truncateString
	}
})
export default class SetupOverviewServer extends Vue {
	@Prop({ required: true, default: null }) private selectedNode: SystemViewTreeNode;

	@Getter getPermissions: UserPermissions;
	@Getter("getFeaturesList") featuresList: FeaturesList;

	private setupResponse: SetupSummaryResponse =  null;
	private serverOverview: ServerOverview = null;

	private showPassword: boolean = false;
	private passwordButtonText: string = "Show";
	private customFieldObjectValues: CustomFieldValues[] = [];
	private serverCustomFieldTableType: number = CustomFieldTableTypes.Server;

	private async mounted(): Promise<void> {
		await this.retrieveServerDetails();
	}

	@Watch("selectedNode", { deep: true })
	private async retrieveServerDetails(): Promise<void> {
		if(this.selectedNode && this.canUseSystemView)
		{
			this.serverOverview = null; // Reset previous display data

			this.setupResponse = await api.getSetupSummary(this.selectedNode.objectTypeId, this.selectedNode.objectId)

			if (this.setupResponse && !this.setupResponse?.error) {
				try {
					this.serverOverview = JSON.parse(this.setupResponse.summary) as ServerOverview
				}
				catch(e) {
					console.error("Failed to Parse server summary: "+ e)
					this.setupResponse.error = "Failed to Parse server summary";
				}
			}

			if (this.isCustomFieldServerEnabled) {
				try
				{
					this.customFieldObjectValues = await customFieldsApi.retrieveCustomFieldsForObject(
						this.selectedNode.objectId,
						CustomFieldTableTypes.Server
					);
				}
				catch (e)
				{
					console.error(
					"Failed to get Custom Fields for object with objectId: " + this.selectedNode.objectId);
					this.customFieldObjectValues = [];
				}
			}
			else
			{
				this.customFieldObjectValues = [];
			}
		}
	}

	private get canUseSystemView(): boolean {
        return get(this.featuresList, ["SystemView"]) && (this.getPermissions.canViewSystemView || this.getPermissions.isSystemAdmin);
    }

	private get canUseDevicePing(): boolean {
		return  get(this.featuresList, ["SystemView", "PingDeviceStatus"]) && this.canUseSystemView;
	}

	private get isCustomFieldServerEnabled(): boolean {
		return get(this.featuresList, ["CustomFields", "Servers"]);
	}

	private shouldRefreshHistory(): void {
		this.$emit("should-refresh-history");
	}

	private get customFieldsAvailable(): boolean {
		return !!this.customFieldObjectValues &&
			this.customFieldObjectValues?.length > 0
	}

}
